import { DatePipe, formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'date_date' })
export class DateDatePipe {
    constructor() {}
    transform(value: string): string | null {
        return new DatePipe('en-CA').transform(value, 'YYYY-MM-dd');
    }
}
